import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Button, ButtonIcon } from '../button'
import { HStack } from '../hstack'
import { Text } from '../text'
import { type ZoomControlsProps } from './ZoomControls.types'

const buttonClassName = 'h-8 w-8 p-1 rounded border-solid'

export function ZoomControls({
    zoomLabel,
    onZoomIn,
    onZoomOut,
    onReset,
    minusIcon,
    plusIcon,
    disabledZoomIn,
    disabledZoomOut,
    zoomInLabel = 'Zoom in',
    zoomOutLabel = 'Zoom out',
    resetLabel = 'Reset zoom',
    className,
}: ZoomControlsProps) {
    return (
        <HStack
            className={twMerge(
                'flex-row items-center gap-1 p-1 rounded-lg bg-aos-bg-input border border-solid border-border-subtle',
                className,
            )}
        >
            <Button
                accessibilityLabel={zoomOutLabel}
                onPress={onZoomOut}
                disabled={disabledZoomOut}
                variant='secondary'
                className={buttonClassName}
            >
                <ButtonIcon as={minusIcon} size={24} />
            </Button>
            <Button
                accessibilityLabel={resetLabel}
                onPress={onReset}
                disabled={!onReset}
                variant='text'
                className='h-auto p-1 rounded hover:bg-aos-bg-input-hover'
            >
                <Text size='P3' weight='medium' tone='default' className='w-10 text-center'>
                    {zoomLabel}
                </Text>
            </Button>
            <Button
                accessibilityLabel={zoomInLabel}
                onPress={onZoomIn}
                disabled={disabledZoomIn}
                variant='secondary'
                className={buttonClassName}
            >
                <ButtonIcon as={plusIcon} size={24} />
            </Button>
        </HStack>
    )
}
